module.exports = __webpack_public_path__ + "img/lowerchestcircumference.91d0142f.jpeg";